import React from 'react';
import { motion } from 'framer-motion';
export function OtlIntro() {
  return <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 mb-24" data-id="element-290">
      <div className="lg:col-span-5" data-id="element-291">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-292">
          Objetos Territoriales Legales (OTL)
        </motion.span>
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-5xl font-serif text-forest mb-6 leading-tight" data-id="element-293">
          Información clara para conocer, consultar y cuidar el territorio
        </motion.h2>
      </div>

      <div className="lg:col-span-7 space-y-12" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-295">
          <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-296">
            ¿Qué son los OTL?
          </h3>
          <div className="space-y-4 text-charcoal/80 font-light leading-relaxed" data-id="element-297">
            <p data-id="element-298">
              Los Objetos Territoriales Legales, conocidos como OTL, son
              elementos del territorio que han sido delimitados oficialmente
              mediante una norma, un acto administrativo o una decisión de una
              autoridad competente. Esta delimitación permite reconocer que en
              esos lugares existen condiciones especiales para su uso, manejo,
              protección o administración.
            </p>
            <p data-id="element-299">
              Dicho de manera sencilla, un OTL no es solo una línea en un mapa,
              es una forma de identificar un área geográfica que tiene reglas
              claras y efectos reales para la vida de las personas, las
              comunidades, las empresas y las entidades públicas.
            </p>
            <p data-id="element-300">
              Por ejemplo, cuando se delimita un páramo, una reserva forestal,
              una ronda hídrica o un humedal, también se establecen
              orientaciones sobre qué actividades se pueden realizar, cuáles
              deben limitarse y qué responsabilidades existen para proteger ese
              espacio.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} data-id="element-301">
          <h3 className="font-serif text-2xl text-forest mb-4" data-id="element-302">
            ¿Por qué son importantes?
          </h3>
          <div className="space-y-4 text-charcoal/80 font-light leading-relaxed" data-id="element-303">
            <p data-id="element-304">
              Los OTL ayudan a que la información geoespacial sea más clara,
              confiable y fácil de usar. Gracias a ellos, las entidades públicas
              pueden tomar mejores decisiones sobre conservación ambiental,
              ordenamiento territorial, gestión del suelo, planeación y
              protección de los recursos naturales.
            </p>
            <p data-id="element-305">
              También son útiles para la ciudadanía, porque permiten conocer si
              un predio, una vereda, un municipio o una zona determinada hace
              parte de un área con reglas ambientales o territoriales
              específicas. Esto facilita la consulta de información oficial y
              contribuye a prevenir conflictos por el uso del suelo.
            </p>
            <p data-id="element-306">
              En la práctica, los OTL permiten responder preguntas como: ¿esta
              zona tiene alguna restricción ambiental?, ¿qué entidad administra
              esta figura?, ¿qué norma la creó?, ¿cuáles son sus límites?, ¿qué
              responsabilidades existen para su conservación?
            </p>
          </div>
        </motion.div>
      </div>
    </div>;
}